'use client';

import { usePathname } from 'next/navigation';
import type { FC } from 'react';
import { useEffect } from 'react';

import { useAuth } from '@sola/auth-sdk/store.tsx';
import { useCart } from '@sola/cart-sdk/store.tsx';
import { trackUser } from '@sola/tracking/lib/analytics/events.ts';

/**
 * Centralizes the "initial_push" analytics tracking. This component depends on
 * `auth-sdk` and `cart-sdk`, which `tracking` can't do without creating a
 * circular dependency.
 */
export const TrackUser: FC = () => {
  const pathname = usePathname();
  const { isReady: isAuthReady, authUser } = useAuth(
    'isReady',
    'isLoggedIn',
    'authUser',
  );
  const { isReady: isCartReady, cart } = useCart('isReady', 'cart');

  useEffect(() => {
    if (!isAuthReady || !isCartReady) {
      return;
    }
    trackUser(authUser, cart);
  }, [pathname, isAuthReady, isCartReady]);

  return null;
};
